<script setup lang="ts">
    import { TweakPanel } from '@/commons/TweakPanel';
    import { useConfigStore } from '@/store/config.store';
    import { Wedding3DWorld } from '@/littleWedding/Wedding3DWorld';
    import { customMaterialSetup } from '@/littleWedding/physicalMaterialSetup';
    import { meshBasicMaterial } from '@/config';
    import { onMounted, onUnmounted, useTemplateRef, watch } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useElementSize } from '@vueuse/core';

    let wedding3DWorld: Wedding3DWorld;
    const canvasContainerRef = useTemplateRef<HTMLCanvasElement | null>('canvas-container');
    const container = useElementSize(canvasContainerRef);

    const { isMobile, productType } = storeToRefs(useConfigStore());

    customMaterialSetup(meshBasicMaterial);

    onMounted(() => {
        if (import.meta.env.MODE !== 'production') {
            TweakPanel.init({
                title: 'PMEA',
                expanded: true,
                container: document.querySelector('#tweakpane-container') as HTMLDivElement,
            });
        }

        wedding3DWorld = new Wedding3DWorld({
            container: document.querySelector('#container-webgl-canvas') as HTMLDivElement,
            customMaterial: meshBasicMaterial,
            productType: productType.value,
            webGLParameters: {
                canvas: document.querySelector('#webgl-canvas') as HTMLCanvasElement,
                antialias: true,
            },
        });
    });

    watch(
        () => [container.width.value, container.height.value],
        ([oldWidth, oldHeight], [newWidth, newHeight]) => {
            if (oldWidth !== newWidth || oldHeight !== newHeight) {
                Wedding3DWorld.instance?.resize();
            }
        },
    );

    onUnmounted(() => {
        wedding3DWorld.dispose();
        if (TweakPanel.isInitialized) {
            TweakPanel.dispose();
        }
    });
</script>

<template>
    <div
        id="container-webgl-canvas"
        ref="canvas-container"
        :class="[isMobile && 'h-dvh', !isMobile && 'h-full', 'relative w-full']"
    >
        <div
            id="main-tweakpane-container"
            class="main-tweakpane-container"
        >
            <div
                id="tweakpane-container"
                class="tweakpane-container"
            ></div>
        </div>
        <canvas
            id="webgl-canvas"
            :class="[isMobile && 'h-dvh', !isMobile && 'h-full']"
        />
    </div>
</template>

<style scoped>
    #webgl-canvas {
        position: relative;
        width: 100%;
    }

    #fullscreen {
        position: absolute;
        top: 128px;
        right: 1em;
        cursor: pointer;
    }

    #main-tweakpane-container {
        position: absolute;
        z-index: 100;
        top: 0;
        right: 30vw;
    }
    #bufferCanvas {
        background-color: red;
        width: auto;
        height: 100vh;
        position: fixed;
        top: 0;
        right: 25%;
        z-index: 100;
        pointer-events: none;
        opacity: 0;
    }
</style>
